export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '最新更新', href: '#updates' },
  { label: '热播榜单', href: '#ranking' },
  { label: '专题合集', href: '#index' },
  { label: 'APP下载', href: '#app' },
];

export const heroData = {
  tag: '每日更新 · 高清流畅',
  title: '2828电影网',
  subtitle: '免费电视剧全集在线看',
  description: '2828电影网汇集海量免费电视剧资源，涵盖最新国产剧、高分海外剧、经典老剧等全类型内容。每日同步更新最新剧集，高清画质流畅不缓冲，无需注册即可在线观看。无论是热播都市剧、悬疑推理、古装传奇还是轻松喜剧，都能在这里找到属于你的追剧节奏。',
  stats: [
    { label: '每日更新剧集', value: '200+' },
    { label: '高清片源覆盖', value: '98%' },
    { label: '全类型覆盖', value: '30+' },
  ],
  primaryCta: { label: '开始追剧', href: '#carousel' },
  secondaryCta: { label: '查看榜单', href: '#ranking' },
};

export const carouselItems = [
  {
    id: 1,
    title: '《暗夜追踪》热播进行中',
    subtitle: '悬疑犯罪大剧 · 豆瓣8.7分',
    description: '一桩离奇命案牵扯出尘封二十年的惊天秘密，刑警队长周远与天才侧写师林小满联手破局，层层反转，直击人性深处。全剧36集，现已更新至第28集。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20crime%20drama%20scene%20with%20detective%20standing%20in%20rainy%20city%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20noir%20aesthetic%2C%20film%20grain%20texture%2C%20dramatic%20lighting%20with%20long%20shadows%2C%20warm%20amber%20and%20deep%20red%20color%20tones%2C%20movie%20poster%20style%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '热播推荐',
    badge: '更新至28集',
  },
  {
    id: 2,
    title: '《春风十里》都市情感力作',
    subtitle: '都市温情剧 · 口碑持续走高',
    description: '四个年轻人在大城市打拼的故事，有笑有泪有温暖。当理想撞上现实，他们如何在钢筋森林里守护初心与爱情？40集都市情感大剧，全网热播。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20urban%20romance%20scene%20with%20young%20couple%20walking%20through%20cherry%20blossom%20tree-lined%20street%20in%20modern%20city%2C%20soft%20golden%20sunset%20light%2C%20dreamy%20bokeh%20background%2C%20spring%20atmosphere%2C%20cinematic%20widescreen%20composition%2C%20warm%20pastel%20tones%2C%20film%20poster%20aesthetic&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '口碑好剧',
    badge: '全网热播',
  },
  {
    id: 3,
    title: '《苍穹之刃》古装史诗巨制',
    subtitle: '奇幻古装大戏 · 年度期待',
    description: '少年凌渊背负灭门之仇踏入修仙之路，在正邪交锋中逐渐揭开天地玄机。特效震撼，打戏精彩，世界观宏大。全剧48集，正在热播。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20ancient%20Chinese%20drama%20scene%20with%20warrior%20standing%20on%20misty%20mountain%20peak%20holding%20sword%2C%20flowing%20traditional%20robes%20in%20wind%2C%20dramatic%20clouds%20and%20golden%20sunlight%20breaking%20through%2C%20cinematic%20widescreen%20composition%2C%20rich%20warm%20gold%20and%20deep%20crimson%20tones%2C%20movie%20poster%20style&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '年度巨制',
    badge: '热播中',
  },
  {
    id: 4,
    title: '《职场风云录》现实主义话题剧',
    subtitle: '职场生存指南 · 引发全网讨论',
    description: '聚焦互联网大厂职场生态，揭露打工人的真实困境与突围之路。没有主角光环，只有真实的人性和抉择。30集精品短剧，一集入坑。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20drama%20scene%20with%20young%20professionals%20working%20in%20contemporary%20open-plan%20workspace%2C%20glass%20walls%20and%20warm%20interior%20lighting%2C%20serious%20expressions%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field%2C%20warm%20amber%20and%20cream%20tones%2C%20realistic%20corporate%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '话题热剧',
    badge: '全集上线',
  },
  {
    id: 5,
    title: '《深海密码》科幻悬疑新标杆',
    subtitle: '硬核科幻 · 国产剧新突破',
    description: '深海科考队在一次例行任务中意外发现神秘信号源，由此揭开人类文明未知篇章。特效比肩国际水准，剧情烧脑缜密。24集科幻大剧。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20sea%20research%20station%20interior%20with%20blue%20glowing%20holographic%20displays%20and%20scientists%20in%20futuristic%20gear%2C%20submarine%20window%20showing%20dark%20ocean%20depths%2C%20cinematic%20sci-fi%20aesthetic%2C%20dramatic%20lighting%20with%20warm%20accent%20lights%2C%20film%20poster%20composition&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '科幻力作',
    badge: '高能预定',
  },
  {
    id: 6,
    title: '《烟火人间》温暖家庭剧',
    subtitle: '治愈系生活剧 · 笑泪交织',
    description: '一个普通家庭三代人的日常烟火，平凡日子里藏着最深的爱。没有狗血剧情，只有真实到让你会心一笑的生活点滴。36集，每日更新。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20dinner%20scene%20in%20cozy%20Chinese%20home%20with%20three%20generations%20gathered%20around%20table%20full%20of%20food%2C%20soft%20warm%20lighting%20from%20overhead%20lamp%2C%20joyful%20expressions%2C%20steam%20rising%20from%20dishes%2C%20cinematic%20composition%2C%20rich%20golden%20and%20cream%20tones%2C%20lifestyle%20photography%20style&width=1200&height=600&seq=carousel-06&orientation=landscape',
    tag: '温情治愈',
    badge: '每日更新',
  },
];

export const contactData = {
  title: '剧迷投稿 & 资源反馈',
  description: '有想看的剧？发现链接失效？欢迎随时告诉我们，追剧路上我们一起维护最好的观影体验。',
  email: 'feedback@2828dy.com',
  note: '我们会在24小时内处理你的反馈',
};

export const topicItems = [
  { label: '国产剧', count: '3.2万讨论', href: '#index', hot: true },
  { label: '悬疑推理', count: '2.8万讨论', href: '#index', hot: true },
  { label: '古装传奇', count: '2.5万讨论', href: '#index', hot: true },
  { label: '都市情感', count: '2.1万讨论', href: '#index', hot: false },
  { label: '科幻巨制', count: '1.9万讨论', href: '#index', hot: false },
  { label: '高分韩剧', count: '1.7万讨论', href: '#index', hot: false },
  { label: '美剧精选', count: '1.5万讨论', href: '#index', hot: false },
  { label: '日剧经典', count: '1.3万讨论', href: '#index', hot: false },
  { label: '纪录片', count: '1.1万讨论', href: '#index', hot: false },
];

export const aboutData = {
  title: '关于2828电影网',
  paragraphs: [
    '2828电影网是一个专注于免费电视剧在线观看的综合性平台。自成立以来，我们始终坚持「高清、免费、无广告干扰」的核心理念，致力于为广大剧迷提供最舒适便捷的追剧体验。平台覆盖国产剧、韩剧、美剧、日剧、纪录片等全品类内容，每日同步更新最新剧集资源。',
    '我们深知追剧是一件需要沉浸感的事情。因此，2828电影网在片源选择上严格把关画质标准，确保每一部剧集都能以高清流畅的画质呈现。同时，我们的技术团队持续优化播放体验，即使在移动网络环境下也能享受不缓冲的顺畅观影。',
    '作为一个纯粹的影视分享平台，2828电影网不设付费墙、无需注册登录，让每一位访问者都能毫无门槛地开始追剧之旅。我们相信，好的内容值得被更多人看到。',
  ],
};

export const cardItems = [
  {
    id: 1,
    title: '高分国产剧《繁城之下》',
    category: '悬疑 · 古装',
    description: '豆瓣8.9分年度神作，明朝背景下的小人物探案故事，环环相扣引人入胜。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20town%20at%20night%20with%20lanterns%20and%20mist%2C%20mysterious%20atmosphere%2C%20traditional%20architecture%2C%20warm%20glowing%20lights%20from%20windows%2C%20cinematic%20composition%2C%20rich%20amber%20and%20deep%20brown%20tones%2C%20drama%20poster%20style&width=800&height=450&seq=card-01&orientation=landscape',
    rating: '8.9',
    tag: '高分必看',
  },
  {
    id: 2,
    title: '韩剧《无声的呐喊》',
    category: '犯罪 · 悬疑',
    description: '改编自真实事件的犯罪悬疑剧，每集一个案件，节奏紧凑全程无尿点。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20detective%20drama%20scene%20with%20two%20investigators%20in%20dark%20alley%2C%20rain%20falling%2C%20reflective%20wet%20ground%2C%20neon%20sign%20reflections%2C%20cinematic%20noir%20lighting%2C%20warm%20amber%20street%20lights%2C%20dramatic%20composition%2C%20film%20poster%20aesthetic&width=800&height=450&seq=card-02&orientation=landscape',
    rating: '8.7',
    tag: '韩剧精选',
  },
  {
    id: 3,
    title: '都市剧《三十而骊》',
    category: '都市 · 情感',
    description: '三位三十岁女性的自我成长故事，真实扎心又温暖治愈，引发全网共鸣。',
    image: 'https://readdy.ai/api/search-image?query=Three%20elegant%20women%20in%20modern%20city%20cafe%2C%20warm%20afternoon%20sunlight%20through%20large%20windows%2C%20stylish%20contemporary%20fashion%2C%20laughing%20together%2C%20cinematic%20composition%2C%20soft%20cream%20and%20rose%20gold%20tones%2C%20lifestyle%20photography%20style&width=800&height=450&seq=card-03&orientation=landscape',
    rating: '8.5',
    tag: '口碑热播',
  },
  {
    id: 4,
    title: '美剧《边缘世界》第二季',
    category: '科幻 · 惊悚',
    description: '未来科技与人性边界的深度探讨，视效炸裂，每集都是电影级制作水准。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20city%20skyline%20at%20dusk%20with%20holographic%20advertisements%20and%20flying%20vehicles%2C%20neon%20lights%2C%20cyberpunk%20aesthetic%20with%20warm%20orange%20and%20gold%20accents%2C%20cinematic%20widescreen%2C%20dramatic%20sky%20colors&width=800&height=450&seq=card-04&orientation=landscape',
    rating: '9.1',
    tag: '美剧精选',
  },
  {
    id: 5,
    title: '纪录片《人间有味》',
    category: '美食 · 人文',
    description: '走遍中国寻味地道美食，每一帧都是壁纸，讲述食物背后的人生百态。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20street%20food%20market%20with%20steaming%20dishes%20and%20colorful%20ingredients%2C%20warm%20evening%20light%2C%20busy%20cooks%20in%20traditional%20stall%2C%20rich%20textures%20and%20warm%20golden%20tones%2C%20cinematic%20food%20photography%20style&width=800&height=450&seq=card-05&orientation=landscape',
    rating: '9.3',
    tag: '纪录佳作',
  },
  {
    id: 6,
    title: '日剧《深夜便当屋》',
    category: '治愈 · 美食',
    description: '深夜营业的小小便当屋，温暖了无数都市夜归人的胃和心。日式治愈天花板。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20small%20restaurant%20at%20night%20with%20warm%20yellow%20lantern%20light%2C%20wooden%20interior%2C%20steaming%20food%20on%20counter%2C%20quiet%20atmosphere%2C%20cinematic%20composition%2C%20rich%20golden%20and%20brown%20tones%2C%20intimate%20setting&width=800&height=450&seq=card-06&orientation=landscape',
    rating: '9.2',
    tag: '日剧推荐',
  },
  {
    id: 7,
    title: '古装剧《长安十二时辰》',
    category: '历史 · 悬疑',
    description: '盛世长安的二十四小时反恐实录，服化道考究，每一帧都是盛唐美学。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20street%20at%20sunset%2C%20traditional%20architecture%20with%20red%20lanterns%2C%20busy%20market%20scene%2C%20guards%20in%20traditional%20armor%2C%20cinematic%20widescreen%2C%20rich%20red%20and%20gold%20tones%2C%20historical%20epic%20atmosphere&width=800&height=450&seq=card-07&orientation=landscape',
    rating: '8.8',
    tag: '古装精选',
  },
];

export const rankingItems = [
  { rank: 1, title: '暗夜追踪', category: '悬疑犯罪', hot: '本周播放量 2800万', change: 'up', episodes: '更新至28集' },
  { rank: 2, title: '苍穹之刃', category: '奇幻古装', hot: '本周播放量 2450万', change: 'up', episodes: '更新至32集' },
  { rank: 3, title: '春风十里', category: '都市情感', hot: '本周播放量 2100万', change: 'down', episodes: '更新至18集' },
  { rank: 4, title: '深海密码', category: '科幻悬疑', hot: '本周播放量 1950万', change: 'up', episodes: '全24集' },
  { rank: 5, title: '职场风云录', category: '现实主义', hot: '本周播放量 1820万', change: 'new', episodes: '全30集' },
];

export const updateItems = [
  {
    id: 1,
    date: '07-31',
    title: '《暗夜追踪》第29集更新上线',
    category: '剧集更新',
    description: '周远发现关键线索，案件迎来重大转折。本集高能预警，建议备好零食再看。',
  },
  {
    id: 2,
    date: '07-31',
    title: '《苍穹之刃》第33集更新上线',
    category: '剧集更新',
    description: '凌渊突破元婴境界，正邪大战一触即发。特效高能场面千万别错过。',
  },
  {
    id: 3,
    date: '07-30',
    title: '新剧《长安十二时辰》上架',
    category: '新剧入库',
    description: '易烊千玺、雷佳音主演，豆瓣8.8分盛唐悬疑大剧。全48集一次上线，建议通宵。',
  },
  {
    id: 4,
    date: '07-30',
    title: '《春风十里》会员提前看更新',
    category: '剧集更新',
    description: '第19-20集双更放送，感情线迎来重要转折，准备好纸巾。',
  },
  {
    id: 5,
    date: '07-29',
    title: '纪录片《人间有味》全集上线',
    category: '新剧入库',
    description: '美食人文纪录片天花板，12集全系列一次放出，下饭必备。',
  },
  {
    id: 6,
    date: '07-29',
    title: '韩剧《无声的呐喊》全集上线',
    category: '新剧入库',
    description: '16集韩国悬疑口碑剧全集上线。改编真实案件，每集都是电影质感。',
  },
  {
    id: 7,
    date: '07-28',
    title: '《深海密码》大结局上线',
    category: '大结局',
    description: '科幻烧脑神剧迎来终章，最后三集连更。结局到底怎么回事？看完记得来讨论。',
  },
  {
    id: 8,
    date: '07-28',
    title: '周末专题「夏日悬疑夜」上线',
    category: '专题活动',
    description: '精选10部高分悬疑剧，从国产到海外全覆盖。周末宅家一口气刷完。',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-movie-2-line',
    title: '海量片源',
    description: '覆盖国产剧、韩剧、美剧、日剧等30+品类，每天持续更新最新剧集资源，总有一部适合你。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清画质',
    description: '98%片源达到1080P及以上清晰度标准，支持多码率自适应，根据网络环境智能切换最佳画质。',
  },
  {
    id: 3,
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    description: '全球CDN加速节点覆盖，智能预加载技术确保观影过程丝滑流畅，告别转圈等待。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '纯净追剧',
    description: '无弹窗广告干扰，无强制注册，打开即看。我们承诺给你最纯粹的追剧环境。',
  },
];

export const indexItems = [
  {
    id: 1,
    title: '暑期档必刷清单',
    subtitle: '10部高能好剧陪你过夏天',
    description: '悬疑、古装、都市全覆盖，精选暑期档口碑最佳剧集，一部都不能错过。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20vibes%20collection%20of%20colorful%20drama%20posters%20arranged%20artistically%20on%20warm%20background%2C%20tropical%20leaves%20decorations%2C%20cinematic%20lighting%2C%20rich%20golden%20and%20coral%20tones%2C%20curated%20aesthetic%20flatlay%20style&width=600&height=400&seq=index-01&orientation=landscape',
    count: '10部精选',
  },
  {
    id: 2,
    title: '悬疑推理专场',
    subtitle: '烧脑不停，反转不断',
    description: '从国产悬疑到海外神剧，精选高分悬疑推理作品，挑战你的推理极限。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20theme%20collage%20with%20magnifying%20glass%20and%20old%20documents%20on%20dark%20wooden%20desk%2C%20warm%20desk%20lamp%20light%2C%20vintage%20detective%20atmosphere%2C%20rich%20brown%20and%20gold%20tones%2C%20cinematic%20still%20life%20composition&width=600&height=400&seq=index-02&orientation=landscape',
    count: '15部精选',
  },
  {
    id: 3,
    title: '古装美学盛宴',
    subtitle: '服化道天花板都在这里',
    description: '精选制作精良的古装剧，从服化道到场景设计，每一帧都是视觉享受。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20silk%20fabric%20and%20ancient%20accessories%20arranged%20on%20dark%20wood%20surface%2C%20soft%20natural%20light%2C%20elegant%20composition%2C%20rich%20red%20and%20gold%20textures%2C%20historical%20aesthetic%20still%20life%20photography&width=600&height=400&seq=index-03&orientation=landscape',
    count: '12部精选',
  },
  {
    id: 4,
    title: '高分韩剧合集',
    subtitle: '从经典到最新，一次收齐',
    description: '豆瓣8分以上韩剧精选，涵盖悬疑、爱情、现实题材，部部都是口碑保证。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20themed%20flatlay%20with%20warm%20coffee%20and%20soft%20blanket%2C%20autumn%20leaves%2C%20cozy%20reading%20nook%2C%20golden%20afternoon%20light%20through%20window%2C%20rich%20cream%20and%20amber%20tones%2C%20lifestyle%20photography&width=600&height=400&seq=index-04&orientation=landscape',
    count: '20部精选',
  },
  {
    id: 5,
    title: '美剧口碑神作',
    subtitle: 'IMDb高分，一季入坑',
    description: '精选高口碑美剧，从经典老剧到最新季，涵盖科幻、犯罪、剧情等多元题材。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reels%20and%20vintage%20movie%20posters%20arranged%20on%20industrial%20style%20desk%2C%20warm%20Edison%20bulb%20lighting%2C%20Hollywood%20nostalgia%20vibe%2C%20rich%20golden%20and%20brown%20tones%2C%20creative%20workspace%20photography&width=600&height=400&seq=index-05&orientation=landscape',
    count: '18部精选',
  },
  {
    id: 6,
    title: '纪录片宝藏库',
    subtitle: '涨知识又下饭',
    description: '精选高分纪录片，从自然地理到人文历史，开阔眼界的同时享受视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20themed%20flatlay%20with%20vintage%20globe%20and%20field%20notebook%2C%20dried%20flowers%20and%20camera%2C%20warm%20sunlight%2C%20explorer%20aesthetic%2C%20rich%20green%20and%20gold%20tones%2C%20travel%20journal%20photography%20style&width=600&height=400&seq=index-06&orientation=landscape',
    count: '25部精选',
  },
  {
    id: 7,
    title: '经典老剧重温',
    subtitle: '那些年我们一起追过的剧',
    description: '经典永不过时，精选2000-2015年经典国产剧，重温那些年的追剧记忆。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20television%20set%20with%20nostalgic%20family%20living%20room%20setting%2C%20warm%20evening%20light%20from%20window%2C%20retro%20Chinese%20home%20decor%2C%20cozy%20atmosphere%2C%20rich%20amber%20and%20cream%20tones%2C%20nostalgic%20lifestyle%20photography&width=600&height=400&seq=index-07&orientation=landscape',
    count: '30部精选',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20style%20illustration%20of%20young%20person%20on%20warm%20cream%20background%2C%20soft%20shadows%2C%20clean%20modern%20avatar%20style%2C%20warm%20neutral%20tones&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '2828电影网真的是我发现的宝藏！画质超清晰，而且真的不卡顿。之前在其他平台追《暗夜追踪》，每到关键剧情就缓冲，气得想摔手机。换了2828以后再也没有这种情况了，更新也很及时，强烈推荐！',
    date: '3天前',
    show: '暗夜追踪',
  },
  {
    id: 2,
    name: '深夜追剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20style%20illustration%20of%20person%20with%20glasses%20on%20warm%20cream%20background%2C%20soft%20shadows%2C%20clean%20modern%20avatar%20style%2C%20warm%20neutral%20tones&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '作为一个悬疑剧重度爱好者，这里的高分悬疑片库太全了吧！韩剧《无声的呐喊》全集一次性上线，熬夜刷完，爽到飞起。不用注册直接看真的太方便了，已经安利给身边所有朋友。',
    date: '5天前',
    show: '无声的呐喊',
  },
  {
    id: 3,
    name: '周末观影指南',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20style%20illustration%20of%20smiling%20person%20on%20warm%20cream%20background%2C%20soft%20shadows%2C%20clean%20modern%20avatar%20style%2C%20warm%20neutral%20tones&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '纪录片《人间有味》真的绝了！每集都像在看电影，美食+人文的组合太上头。2828的专题合集也很用心，「夏日悬疑夜」那个专题选的剧全是高分，省去了自己找剧的麻烦，良心平台！',
    date: '1周前',
    show: '人间有味',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '《暗夜追踪》终极预告',
    description: '一桩命案，二十年秘密，层层反转高能不断',
    image: 'https://readdy.ai/api/search-image?query=Intense%20crime%20drama%20trailer%20scene%20with%20detective%20running%20through%20dark%20alley%2C%20dramatic%20lighting%2C%20cinematic%20motion%20blur%2C%20warm%20street%20lights%2C%20film%20poster%20style%2C%20deep%20red%20and%20amber%20tones%2C%20thriller%20aesthetic&width=800&height=450&seq=media-01&orientation=landscape',
    duration: '2:35',
    tag: '预告片',
  },
  {
    id: 2,
    title: '《苍穹之刃》幕后特辑',
    description: '走进年度奇幻巨制的制作幕后，揭秘惊人特效诞生过程',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20fantasy%20film%20production%20with%20green%20screen%20studio%20and%20crew%20members%2C%20professional%20film%20equipment%2C%20warm%20studio%20lighting%2C%20cinematic%20documentary%20style%2C%20rich%20golden%20tones&width=800&height=450&seq=media-02&orientation=landscape',
    duration: '8:12',
    tag: '幕后花絮',
  },
  {
    id: 3,
    title: '「夏日悬疑夜」主题混剪',
    description: '10部高分悬疑剧精彩片段混剪，感受肾上腺素飙升',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20film%20editing%20suite%20with%20multiple%20monitors%20showing%20thriller%20movie%20scenes%2C%20warm%20ambient%20lighting%2C%20professional%20video%20editing%20setup%2C%20cinematic%20workspace%2C%20rich%20amber%20and%20dark%20red%20tones&width=800&height=450&seq=media-03&orientation=landscape',
    duration: '4:48',
    tag: '精彩混剪',
  },
];

export const appData = {
  title: '随时随地，追剧不停',
  subtitle: '下载2828电影网APP，享受更流畅的移动追剧体验',
  features: [
    '离线缓存，无网络也能看',
    '投屏到电视，大屏更过瘾',
    '更新推送，新剧集不错过',
    '夜间模式，护眼追剧更舒适',
  ],
  qrImage: 'https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20design%20on%20warm%20cream%20background%20with%20soft%20shadows%2C%20clean%20modern%20interface%20style%2C%20elegant%20golden%20accent%20border%2C%20simple%20geometric%20composition&width=400&height=400&seq=app-qr&orientation=squarish',
  appImage: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20movie%20streaming%20app%20interface%20on%20screen%20with%20drama%20posters%2C%20clean%20UI%20design%2C%20warm%20background%2C%20floating%20phone%20perspective%2C%20soft%20shadows%2C%20product%20photography%20style%2C%20elegant%20golden%20and%20cream%20tones&width=600&height=700&seq=app-mockup&orientation=portrait',
};

export const faqItems = [
  {
    id: 1,
    question: '2828电影网需要注册才能观看吗？',
    answer: '完全不需要。2828电影网坚持「打开即看」的理念，所有剧集无需注册、无需登录即可免费在线观看。我们相信好的内容不应该设置门槛。',
  },
  {
    id: 2,
    question: '剧集更新频率是怎样的？',
    answer: '我们与各大平台保持同步更新，热门剧集通常在播出后2小时内上线。新剧入库也会第一时间通知，确保你不会错过喜欢的剧集。每日平均更新200+集内容。',
  },
  {
    id: 3,
    question: '支持哪些设备观看？画质如何？',
    answer: '支持电脑、平板、手机等所有主流设备观看，无需安装任何插件。98%以上的片源提供1080P高清画质，部分热门剧集支持4K分辨率。系统会根据你的网络环境自动匹配最佳画质。',
  },
  {
    id: 4,
    question: '观看时卡顿怎么办？',
    answer: '2828电影网采用全球CDN加速技术，正常情况下不会出现卡顿。如果遇到缓冲，建议检查你的网络连接或尝试切换清晰度选项。我们提供多线路备选，确保流畅观影体验。',
  },
  {
    id: 5,
    question: '可以下载剧集离线观看吗？',
    answer: '网页版暂不支持下载功能。如需离线观看，推荐使用2828电影网APP，支持一键缓存剧集到本地，无网络环境下也能随时追剧。',
  },
  {
    id: 6,
    question: '想看的剧没有怎么办？',
    answer: '你可以通过网站的反馈入口告诉我们想看的剧名。我们的内容团队会定期评估用户需求，优先引进呼声最高的剧集。也欢迎关注我们的「最新更新」栏目，新上架的剧会第一时间展示。',
  },
];

export const footerData = {
  description: '2828电影网 — 免费电视剧全集在线观看平台。高清流畅不缓冲，每日更新最新剧集，追剧首选。覆盖国产剧、韩剧、美剧、日剧、纪录片等全品类内容。',
  sections: [
    {
      title: '内容导航',
      links: [
        { label: '焦点专题', href: '#carousel' },
        { label: '热播榜单', href: '#ranking' },
        { label: '最新更新', href: '#updates' },
        { label: '专题合集', href: '#index' },
      ],
    },
    {
      title: '帮助与支持',
      links: [
        { label: '常见问答', href: '#faq' },
        { label: '剧迷反馈', href: '#contact' },
        { label: '关于我们', href: '#about' },
        { label: 'APP下载', href: '#app' },
      ],
    },
  ],
  partnersTitle: '合作伙伴',
  copyright: '© 2026 2828电影网 28dy.com. All Rights Reserved.',
};